<template>
    <component :is="'VuePerfectScrollbar'" class="filters_scroll_area" :settings="settings" :key="$vs.rtl">
        <Filters :filters="selects" @updateData="updateData"/>
    </component>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Filters from '@/pages/Home/ListGlobalComponents/Filters'
import { mapActions, mapGetters } from "vuex";
import axios from "@/configs/Axios";
export default {
    name: "FilterAdviser",
    components:{
        VuePerfectScrollbar,
        Filters,
    },
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            selects: [
                {
                    name:'study_year',   // название фильтра в роутере и перевод
                    placeholder:'choose_an_academic_year',   // что должно отображаться когда фильтр пуст
                    type:'study_years',   // название ендпоинта
                    path:'common',   // название приложения в бекенде
                    trackBy:'uid',   // по какому признаку выделять выбранное
                    label:this.withoutNames,   // лейбл
                    router_field:'uid',   // что закидываем в роутер
                },
                {
                    name:'semester',
                    placeholder:'choose_semester',
                    type:'groups_control_periods',
                    path:'organizations',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
                {
                    name:'studycard_status',
                    placeholder:'studycard_status',
                    type:'student_discipline_info_status',
                    path:'common',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
                {
                    name:'preparation_level_name',
                    placeholder:'preparation_level_name',
                    type:'prep-levels',
                    path:'organizations',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
                {
                    name:'course_of_study',
                    placeholder:'course',
                    type:'courses',
                    path:'common',
                    trackBy:'number',
                    label:this.CourseLabel,
                    router_field:'number',
                },
                {
                    name:'student_status',
                    placeholder:'student_status',
                    type:'student_status',
                    path:'user',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
                {
                    name:'student_load_type',
                    placeholder:'student_load_type',
                    type:'students_and_teachers_load_type',
                    path:'organizations',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
                {
                    name:'advisor',
                    placeholder:'is_supervisor',
                    type:'advisors_list',
                    path:'organizations',
                    trackBy:'uid',
                    label:this.AdvisorLabelField,
                    router_field:'uid',
                },
                {
                    name:'cathedra',
                    placeholder:'department',
                    type:'cathedra_list',
                    path:'common',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
                {
                    name:'education_program_name',
                    placeholder:'direction',
                    type:'education_program_list',
                    path:'common',
                    trackBy:'uid',
                    label:this.withoutNames,
                    router_field:'uid',
                },
            ],
        }
    },
    async created() {
        await this.updateData()
    },
    computed:{
        ...mapGetters({
            GET_NOTIFY_DURATION: 'online_registration/GET_NOTIFY_DURATION'
        }),
    },
    methods:{
        // ...mapActions({
        //     STUDENT_LIST:'online_registration/STUDENT_LIST'
        //
        // }),
        async updateData(){
            if (this.$route.query?.study_year && this.$route.query?.semester){
                try {
                    // await this.STUDENT_LIST(this.$route.query)
                } catch(e) {
                    this.$vs.notify({
                        time: this.GET_NOTIFY_DURATION,
                        text: this.$t(e.error),
                        color: 'danger'
                    })
                }
            }
        },

        withoutNames(item) {return item ? `${ item.name } `: 'Без наименований'},
        AdvisorLabelField(item){return item ? `${ item.full_name }`:'ФИО отсутствует'},
        CourseLabel(item) {return item ? `${ item.number }`:'Без наименований'},
    },
};
</script>

<style lang="scss" scoped>
.title-text {
    font-weight: 600;
}
.required {
    &::after {
        content: "*";
        color: rgba(var(--vs-danger), 1);
        display: inline-block;
        margin-left: 2px;
    }
}
.text-primary {
    color: rgba(var(--vs-primary), 1) !important;
}
</style>
